export default "__VITE_ASSET__DS5LV3dz__"